import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button';
import useCurrentUser from 'hooks/useCurrentUser';
import { useState } from 'react';
import { useCreatePromptSectionMutation } from 'services/api/promptSections.api';
import type { PromptSectionDraft } from 'services/types/promptSection';
import { NAVY, RADIUS_COIN } from 'styles/tokens';

import PromptSectionModal, { type PromptSectionSaveOptions } from './PromptSectionModal';
import SimplePromptSectionModal from './SimplePromptSectionModal';

interface Props {
  businessUnitId: number;
  refetch?: () => void;
}

const NewPromptSectionButton = (props: Props) => {
  const { businessUnitId, refetch } = props;
  const [createPromptSection] = useCreatePromptSectionMutation();
  const [openModal, setOpenModal] = useState(false);
  const currentUser = useCurrentUser();

  const handleCreatePromptSection = async (
    promptSection: PromptSectionDraft,
    options: PromptSectionSaveOptions = { activatePromptVersion: true }
  ) => {
    await createPromptSection({
      businessUnitId,
      promptSection,
      activatePromptVersion: options.activatePromptVersion,
    }).unwrap();
    refetch?.();
  };

  if (!currentUser?.isAdmin) {
    return null;
  }

  const { isAdmin } = currentUser;

  return (
    <>
      <Button
        variant="contained"
        size="small"
        startIcon={<AddIcon />}
        onClick={() => setOpenModal(true)}
        sx={{
          bgcolor: NAVY,
          color: '#fff',
          fontFamily: 'Jost, sans-serif',
          fontWeight: 600,
          textTransform: 'none',
          borderRadius: RADIUS_COIN,
          '&:hover': { bgcolor: NAVY, opacity: 0.9 },
        }}
      >
        Nueva
      </Button>
      {openModal &&
        (isAdmin ? (
          <PromptSectionModal
            close={() => setOpenModal(false)}
            title="Nueva seccion"
            save={handleCreatePromptSection}
            createsPromptVersion={false}
            promptSection={{ name: '', displayName: '', value: '', permission: 'editable', businessUnitId }}
          />
        ) : (
          <SimplePromptSectionModal
            close={() => setOpenModal(false)}
            save={handleCreatePromptSection}
            promptSection={{ name: '', displayName: '', value: '', permission: 'editable', businessUnitId }}
          />
        ))}
    </>
  );
};

export default NewPromptSectionButton;
